export default __webpack_public_path__ + "static/growth-88a96047e846fa5d695ff0d4aeee3a7c.svg";